export default __webpack_public_path__ + "static/media/TIFWCBP.bee75393.pdf";